import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";

export const Heading = styled.h3`
  font-size: 1.25em;
  font-weight: 700;
  line-height: 1.25em;

  @media screen and (min-width: 767px) {
    font-size: 1.125em;
    line-height: 1.125em;
  }

  &:not(:first-child) {
    margin-top: 8px;
  }
`;

export const CarouselLayout = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  gap: 10px;
  margin-bottom: 40px;
  padding: 10px;

  @media screen and (max-width: 1000px) {
    width: 100%;
  }
`;

export const LeftPaddle = styled(FontAwesomeIcon).attrs({ icon: faAngleLeft })`
  font-size: 1.5em;
  color: #0e0e0e;
  cursor: pointer;
  outline: none;
`;

export const RightPaddle = styled(FontAwesomeIcon).attrs({ icon: faAngleRight })`
  font-size: 1.5em;
  color: #0e0e0e;
  cursor: pointer;
  outline: none;
`;

export const IndicatorDots = styled.div`
  position: absolute;
  bottom: -25px;
  transform: translateX(-50%);
  left: 50%;
  display: flex;
  gap: 10px;
`;

export const IndicatorDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${props => props.$selected ? '#0e0e0e' : '#fff'};
  border: 1px solid #0e0e0e;
  cursor: pointer;
  outline: none;
`;

export const WinnerList = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: 1fr;

  height: 150px;
  width: 100%;
  max-width: 650px; 
  position: relative;

  @media screen and (max-width: 767px) {
    height: auto;
    min-width: 0;
    max-width: 310px;
  }
`;

export const FlashContestWinnerItem = styled.div`
  grid-column: 1;
  grid-row: 1;

  width: 100%;
  height: 100%;
  opacity: ${props => props.$visible ? 1 : 0};
  pointer-events: ${props => props.$visible ? 'auto' : 'none'};
  z-index: ${props => props.$visible ? 1 : 0};
  transform: ${props => props.$visible ? 'scale(1)' : 'scale(0.98)'};
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
`;

export const Layout = styled.div`
  display: grid;
  grid-template-columns: 240px 1fr; 

  height: 100%; 
  width: 100%;

  border: #e3e3e3 solid 1px;
  border-radius: 10px;
  overflow: hidden;
  background-color: #fff;

  @media screen and (max-width: 767px) {
    grid-template-columns: 1fr;
    grid-template-rows: 0.75fr 1.25fr;
  }
`;

export const Banner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: 10px;
  background-color: #00c19d;
  color: #fff;

  font-size: 1.25em;
  font-weight: 700;
  line-height: 1.25em;
  text-align: center;
  position: relative;
`;

export const DateRange = styled.div`
  margin-bottom: 5px;
  font-weight: normal;
  font-size: 0.875rem;
  position: absolute;
  width: 100%;
  top: 8px;
  transform: translateX(-50%);
  left: 50%;

  @media screen and (max-width: 767px) {
    top: unset;
    transform: unset;
    left: unset;
    position: relative;
  }
`;

export const FlashContestName = styled.span`
  overflow: hidden;
  overflow-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;

export const Info = styled.div`
  display: flex;
  width: 100%;
  height: 100%;

  @media screen and (max-width: 767px) {
    height: auto;
    flex-direction: column;
  }
`;

export const Section = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 0;
  position: relative;

  border-right: #e3e3e3 solid 1px;
  line-height: 1.5em;
  padding: 10px;

  &:last-child {
    border: none;
  }

  @media screen and (max-width: 767px) {
    border-bottom: #e3e3e3 solid 1px;
  }
`;

export const Label = styled.div`
  color: #666;
  margin-bottom: 5px;
  font-size: 0.875em;
  position: absolute;
  top: 8px;
  transform: translateX(-50%);
  left: 50%;

  @media screen and (max-width: 767px) {
    top: unset;
    transform: unset;
    left: unset;
    position: relative;
  }
`;

export const Name = styled.div`
  font-weight: 700;
  font-size: 1.35em;
  text-align: center;
`;

export const Date = styled.div`
  color: #666;
  margin-bottom: 5px;
  font-size: 0.875em;
  position: absolute;
  top: 8px;
  transform: translateX(-50%);
  left: 50%;

  @media screen and (max-width: 767px) {
    top: unset;
    transform: unset;
    left: unset;
    position: relative;
  }
`;

export const Number = styled.div`
  font-weight: 700;
  font-size: 2em;
  text-wrap: wrap;

  &:before {
    content: "#";
  }
`;

export const Location = styled.div`
  font-size: 0.875em;
  text-align: center;
`;

